<template>
    <v-dialog v-model="dialog" max-width="80%">
        <app-card>
            <app-section-loader :status="loading.submit"></app-section-loader>
            <h4>CHỈNH SỬA GIÁ INTERNET</h4>
            <p class="fs-14 grey--text">Chỉnh sửa giá cho {{ internet_user.user }}</p>
            <v-form ref="form">
                <v-container fluid>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md3>
                            <v-text-field label="Tên user" :disabled="true" v-model="internet_user.user"
                                prepend-icon="account_box"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Số phòng" :disabled="true" v-model="internet_user.room_id"
                                prepend-icon="meeting_room"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Loại wifi" :disabled="true" v-model="wifi_type_text"
                                prepend-icon="wifi"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Tên gói cước" :disabled="loading.submit || isAuxiliaryWifi" v-model="form.package_name"
                                prepend-icon="label"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Tốc độ (Mbps)" :disabled="loading.submit || isAuxiliaryWifi" v-model="form.speed_mbps"
                                prepend-icon="speed" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Giá gói cước" :disabled="loading.submit || isAuxiliaryWifi" v-model="form.price"
                                prepend-icon="money" v-currency></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Giá thu KH" :disabled="loading.submit" v-model="form.customer_price"
                                prepend-icon="money" :rules="[rules.required]" v-currency></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-menu v-model="menu_effective_date" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="form.effective_date" label="Ngày áp dụng" prepend-icon="event" readonly v-bind="attrs" v-on="on" :disabled="loading.submit"></v-text-field>
                                </template>
                                <v-date-picker v-model="form.effective_date" @input="menu_effective_date = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-textarea label="Ghi chú" :disabled="loading.submit" v-model="form.note"
                                prepend-icon="note" rows="3"></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="loading.submit" @click="cancelInput">
                        Trở về
                    </v-btn>
                    <v-btn :loading="loading.submit" :disabled="loading.submit" @click="submit" color="green" dark>
                        Cập Nhật Giá
                    </v-btn>
                </v-card-actions>
            </v-form>
        </app-card>
    </v-dialog>
</template>
<script>
import api from "Api";
import { parseCurrency } from "Helpers";

export default {
    name: "edit-price-dialog",
    props: {
        dialog: Boolean,
        internet_user: Object
    },
    data() {
        return {
            menu_renewal_start_date: false,
            menu_effective_date: false,
            rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            form: {
                customer_price: '',
                note: '',
                price: '',
                package_name: '',
                speed_mbps: '',
                effective_date: '',
            },
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            loading: {
                submit: false
            },
        }
    },
    computed: {
        wifi_type_text() {
            const types = {
                'main': 'Wifi chính',
                'private': 'Wifi riêng',
                'auxiliary': 'Wifi phụ'
            };
            return types[this.internet_user.wifi_type] || this.internet_user.wifi_type;
        },
        isAuxiliaryWifi() {
            return this.internet_user.wifi_type === 'auxiliary';
        }
    },
    watch: {
        dialog(nv) {
            if (nv) {
                this.form.customer_price = this.internet_user.customer_price || this.internet_user.price || '';
                this.form.price = this.internet_user.price || '';
                this.form.note = this.internet_user.note || '';
                this.form.package_name = this.internet_user.package_name || '';
                this.form.speed_mbps = this.internet_user.speed_mbps || '';
                this.form.wifi_type = this.internet_user.wifi_type || '';
                // Luôn set default là thời gian hiện tại
                const today = new Date();
                this.form.effective_date = today.toISOString().substr(0, 10);

            } else {
                this.$refs.form.reset();
            }
        },
    },
    methods: {
        cancelInput() {
            this.$emit('changeDialogState', false);
        },
        async submit() {
            try {
                if (!this.$refs.form.validate()) {
                    swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                    return
                }
                const postData = {
                    _id: this.internet_user._id,
                    price: parseCurrency(this.form.price, "vi-VN", 'VND'),
                    customer_price: parseCurrency(this.form.customer_price, "vi-VN", 'VND'),
                    note: this.form.note,
                    package_name: this.form.package_name || '',
                    speed_mbps: this.form.speed_mbps ? Number(this.form.speed_mbps) : null,
                    effective_date: this.form.effective_date ? new Date(this.form.effective_date).toISOString() : new Date().toISOString(),
                }
                this.loading.submit = true;
                console.log(postData);
                const data = await api.updateInternet(this.internet_user._id, postData)
                this.loading.submit = false;
                if (data.status === 200) {
                    this.$emit('changeDialogState', false);
                    swal.fire('Thành công', 'Cập nhật giá thành công', 'success');
                    this.$emit('reloadTable');
                } else {
                    swal.fire('Lỗi', data.message, 'error');
                }
            } catch (error) {
                console.log("🚀 ~ submit ~ error:", error)
            } finally {
                this.loading.submit = false;

            }
        }
    }
}
</script>